import React, { useState, useEffect } from "react";
import Button from "../components/Button";
import styles from "./EditSubmenuItemModal.module.css";
import { validateForm, validateInput } from "../helpers/helperFunctions";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { flashAlert } from "../global_js";

function EditSubmenuItemModal({ props, setEditModal, menuItems, getMenu }) {
  const [isOpen, setIsOpen] = useState(false);

  const [searchParam, setSearchParam] = useState("");
  const [selections, setSelections] = useState([]);
  const [selectionsRemaining, setSelectionsRemaining] = useState(0);
  const [selectedMenuItem, setSelectedMenuItem] = useState({});
  const [allowedSubitems, setAllowedSubitems] = useState([]);
  const [currentSubitems, setCurrentSubitems] = useState([]);

  // const openModal = () => {
  //   setIsOpen((x) => !x);
  // };
  const closeModal = () => {
    setEditModal({ show: false, props: null });
  };

  const filter = props.Category;

  useEffect(() => {
    getExistingSubmenuItems();
  }, [props]);

  const getExistingSubmenuItems = async () => {
    const res = await fetch("/api/editmenu/submenu/" + props.idBanquetMenu); //+ newItem.idBanquetMenu);
    const currentItems = await res.json();
    const items = menuItems.filter((item) => item.Category == `${filter}_ADD` || item.Category == `${filter}_IT` || item.Category == `SIDE`);
    const sortedItems = items.map((item) => {
      item.selected = false;
      item.required = false;
      currentItems.forEach((sub) => {
        if (item.idBanquetMenu == sub.menuId) {
          item.selected = true;
          item.required = !sub.optional;
        }
      });
      return item;
    });
    setAllowedSubitems(sortedItems);
  };

  const changeSelected = (itemId, selectType) => {
    const newItems = allowedSubitems.map((item) => {
      if (itemId == item.idBanquetMenu) {
        selectType == "s" ? (item.selected = !item.selected) : (item.required = !item.required);
      }
      return item;
    });
    setAllowedSubitems(newItems);
  };

  const saveSubitems = async () => {
    const saveSubmenuList = allowedSubitems.filter((item) => item.selected == true);
    const submitData = { id: props.idBanquetMenu, data: saveSubmenuList };
    await fetch("/api/editmenu/submenu/" + props.idBanquetMenu, {
      method: "put",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(submitData),
    })
      .then((res) => res.json())
      .then((data) => {});
    getMenu();
    closeModal();
  };

  return (
    <>
      <div className={styles.modalBackdrop} id="addSubmenuItemModal">
        <div className={`${styles.modalTop}`}>
          <h3 className={styles.modalHeader}>Add Submenu Item for {props.Item}</h3>

          <div className={styles.menuItemDiv}>
            <table id={`menutable`} className={styles.subMenuItemTable}>
              <thead>
                <tr>
                  <th>Add</th>
                  <th>Sub Item</th>
                  <th>Category</th>
                  <th>Required Choice?</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                {allowedSubitems.length > 0 &&
                  allowedSubitems.map((item) => {
                    return (
                      <tr>
                        <td>
                          <div className={styles.checkboxDiv}>
                            <input
                              type="checkbox"
                              id=""
                              className={styles.checkbox}
                              checked={item.selected}
                              onChange={(e) => changeSelected(item.idBanquetMenu, "s")}
                            />
                          </div>
                        </td>
                        <td>{item.Item}</td>
                        <td>{item.descriptions}</td>
                        <td>
                          <div className={styles.checkboxDiv}>
                            <input
                              type="checkbox"
                              id=""
                              className={styles.checkbox}
                              checked={item.required}
                              onChange={(e) => changeSelected(item.idBanquetMenu, "o")}
                            />
                          </div>
                        </td>
                        <td>{item.Price}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>

          <div className={styles.formSelectButtons}>
            <Button type="primary" onClick={saveSubitems}>
              Save
            </Button>
            <Button type="save" onClick={closeModal}>
              Close
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditSubmenuItemModal;
